import $ from 'jquery';
import { utils } from '../common/utils';
import type { IDonation, IDonorInfo, IDeliveryInfo, IHonoraryInfo } from '../types';
import { DonationAmount } from './donationamount';
import { DonationDeliveryOptions } from './donationdeliveryoptions';
import { DonationGiftForm } from './donationgiftform';
import { DonationPaymentOptions } from './donationpaymentoptions';
import { DonationPayment } from './donationpayment';
import { DonationProgress } from './donationprogress';
import { DonationStatus } from './donationstatus';
import { DonationTabs } from './donationtabs';

export class CelebrationGift implements IDonation {
    private donationflow: HTMLElement & { isMemoryGift?: boolean };
    private $donationflow!: JQuery<HTMLElement>;
    private amountcontrol!: DonationAmount;
    private donationProgress!: DonationProgress;
    private donationGiftForm!: DonationGiftForm;
    private donationDeliveryOptions!: DonationDeliveryOptions;
    private donationTabs!: DonationTabs;
    private statusbox!: DonationStatus;
    private payment!: DonationPayment;
    private paymentOptions!: DonationPaymentOptions;
    readonly isCompany: boolean;

    constructor(element: HTMLElement) {
        this.donationflow = element;
        this.donationflow.isMemoryGift = false;
        this.isCompany = element.getAttribute('data-alz-company') === 'true';
    }

    get DonationElement(): HTMLElement {
        return this.donationflow;
    }

    get $DonationElement(): JQuery<HTMLElement> {
        return this.$donationflow;
    }

    get Amount(): number {
        return this.amountcontrol.getAmount();
    }

    get GiftFormValid(): boolean {
        return this.donationGiftForm.isValid();
    }

    get HonoraryInfo(): IHonoraryInfo {
        return this.donationGiftForm.HonoraryInfo;
    }

    get PaymentValid(): boolean {
        return this.paymentOptions.paymentValid();
    }

    get PaymentMethod(): string {
        return this.paymentOptions.PaymentMethod;
    }

    get DeliverOptionsValid(): boolean {
        return this.donationDeliveryOptions.deliveryOptionsValid();
    }

    get DeliveryInfo(): IDeliveryInfo {
        return this.donationDeliveryOptions.DeliveryInfo;
    }

    get DonorInfo(): IDonorInfo {
        return this.paymentOptions.DonorInfo;
    }

    get StatusBox(): DonationStatus {
        return this.statusbox;
    }

    get CurrentProgress(): number {
        return this.donationProgress.CurrentStep;
    }

    private updateUserInterface(): void {
        this.$donationflow.find('.lbl-yourgift').html(this.Amount.toLocaleString() + ' kr');
    }

    private setupErrorHandler(): void {
        this.$donationflow.on('donationerror', (evt: JQuery.TriggeredEvent) => {
            const detail = (evt.originalEvent as CustomEvent).detail as { error: string };
            this.statusbox.setStatus(detail.error);
            utils.scrollTo(this.statusbox.StatusElement);
        });

        this.$donationflow.on('donationerrorclear', () => {
            this.statusbox.clear();
        });
    }

    private setupTabs(): void {
        this.donationTabs = new DonationTabs(this);
        this.donationflow.addEventListener('stepchanged', () => {
            this.donationProgress.setProgress(this.donationTabs.currentTabStep);
            this.statusbox.clear();
            utils.scrollTo(this.donationProgress.currentElement);
            if (this.donationTabs.onPayment) {
                this.payment.callbackPayment();
            } else {
                this.statusbox.clear();
            }
        });
    }

    private initAmountEvents(): void {
        this.$donationflow.on('amountchanged', () => {
            this.updateUserInterface();
        });
    }

    initEvents(): void {
        this.$donationflow = $(this.donationflow);
        this.donationProgress = new DonationProgress(this.$donationflow.find('.donation-progress')[0]);
        this.donationGiftForm = new DonationGiftForm(this.donationflow);
        this.donationDeliveryOptions = new DonationDeliveryOptions(this.donationflow);
        this.initAmountEvents();
        this.setupTabs();
        this.statusbox = new DonationStatus(this.$donationflow.find('.alert'));
        this.amountcontrol = new DonationAmount(this.donationflow);
        this.paymentOptions = new DonationPaymentOptions(this, 'input[name=tbdeliveryemail]');
        this.payment = new DonationPayment(this, '/api/donations/celebrationdonation', 'celebrationgiftreference');
        this.setupErrorHandler();
        this.updateUserInterface();
    }
}
